import BootslideMenu from 'scoreboard/components/bootslide/bootslide-menu'
import configBackground from '../wob-background-menu'
import i18n from 'scoreboard/components/i18n'
import DataSourceWidgetConfigMenu from '../data-source-widget-config-menu'
import _ from 'lodash'
import fontSizeMenu from '../font-size-menu'
import DomainType from 'scoreboard/components/domain-type'
const { SCORECARD_ITEM, INITIATIVE } = DomainType

var NotesWidgetConfig = DataSourceWidgetConfigMenu.extend({
	typeSpecificTargets: function (hasTemplate) {
		let target = []

		target.push(this.createDataSourceOption({
			model: this.model,
			widgetUpdater: this.options.widgetUpdater,
			allowedDomainTypes: [SCORECARD_ITEM, INITIATIVE],
			// #58542 don't show the period selector for notes widgets
			showPeriodSelector: false
		}))

		let visible = this.model.visibleShowPropertyNames()
		var showingOptions = this.model.validShowProperties().map(function (prop) {
			return {
				id: prop.property,
				hidden: !_.includes(visible, prop.property),
				// Note that this isn't actually displayed, because we override it with contentView.
				// However, it _is_ used for setting the menu item's CSS class, and "title" conflicts
				// with other uses of that class, so I'm just using the property name instead
				label: prop.property,
				contentView: BootslideMenu.WidgetToggleProperty.extend({
					property: { label: prop.label, name: prop.property }
				}),
				model: this.model.properties
			}
		}.bind(this))

		target.push(configBackground(this.model.properties))

		target.push({
			type: 'submenu',
			label: 'common.showing',
			target: showingOptions,
			width: 250
		})

		target.push({
			type: 'submenu',
			label: i18n.get('dashboards.display.displayAs'),
			target: _.map(['full', 'tiles'], mode => {
				let modeLabel = i18n.get('dashboards.display.displayAs.' + mode)
				return {
					label: modeLabel,
					contentView: DisplayModeOption.extend({ value: mode, label: modeLabel }),
					model: this.model.properties
				}
			}),
			width: 200
		})

		target.push(fontSizeMenu(this.model.properties))

		this.listenTo(this.model.properties, 'change:displayMode', () => {
			let visible = this.model.visibleShowPropertyNames()

			this.model.validShowProperties().map(p => p.property).forEach(p => {
				this.bootslide.toggleItem(p, _.includes(visible, p))
			})
		})

		return target
	}
})

var DisplayModeOption = BootslideMenu.WidgetMultipleChoiceOption.extend({
	property: 'displayMode',

	/**
	 * @override
	 */
	updateModel: function (newMode) {
		let update = {}
		update[this.property] = newMode

		// #30103 'full' defaults to 15px and 'tiles' defaults to 13px. If we change
		// modes and the default size was being used in the old mode, use the
		// default size for the new mode
		let fontSize = this.model.get('fontSize')
		if (newMode === 'full' && fontSize == '13') {
			update.fontSize = '15'
		} else if (newMode === 'tiles' && fontSize == '15') {
			update.fontSize = '13'
		}

		this.options.widgetUpdater.setProperties(update)
	}
})

export default NotesWidgetConfig

NotesWidgetConfig.__filename__ = 'dashboards/widgets/notes/notes-widget-config.js'
